import React from "react";
// Fix the typo in folder name (Certifictes -> Certificates)
import image1 from "../../../Assets/Compliance Certifictes/image.png";
import image2 from "../../../Assets/Compliance Certifictes/image2.png";

const GMPInfoContainer = () => {
  return (
    <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
      {/* left side */}
      <div className="w-full">
        {/* heading */}
        <div className="py-4 md:py-10">
          <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
            <h1 className="">
              <span className="border-b-4 border-[#249742]">GET</span> GMP
              CERTIFICATION MUMBAI
            </h1>
          </div>
        </div>

        {/* content */}
        <div>
          <p className="font-normal text-lg text-[#4D4D4D]">
            GDP/GMP stands for Good Manufacturing Practicea nad Good
            Distribution Practices which are the related aspects of quality
            assurance for medicines in European Economic Area. GMP ( Good
            Manufacturing Practices) : It ensures that the products are
            manufactured and controlled under appropriate quality standards to
            their intended use. GDP ( Good Distribution Practices ): It ensures
            that the level of quality determined at GMP is maintained throughout
            the distribution of the product such the authorised medicines are
            distributed to retail pharmacists and others selling medicines
            general public without any alteration of their properties.
          </p>
        </div>
      </div>

      {/* right side */}
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="py-0 sm:py-8">
          <img
            src={image2}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>

        <div className="py-0 sm:py-8">
          <img
            src={image1}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default GMPInfoContainer;
